"use server";

import { api, ErrorResponseData, type AxiosError } from "@/lib/axios";
import { getCookieByName } from "@/lib/cookies";

import {
  TGenericResponse,
  TNotification,
  TResponseServerAction,
} from "./types";

export const getNotifications = async (params: {
  pageNumber: number;
  pageSize: number;
}): Promise<TResponseServerAction<TNotification[]>> => {
  try {
    const response = await api.get<TGenericResponse<TNotification[]>>(
      `/notifications`,
      {
        params,
        headers: {
          Authorization: await getCookieByName("x-api-key"),
        },
      }
    );

    // For client components, return success with the data
    return {
      status: "success",
      message: "Notification fetched successfully",
      metaData: response.data.data,
    };
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponseData>;

    return {
      status: "error",
      message:
        axiosError instanceof Error
          ? axiosError.response?.data?.message || "Notification fetch failed"
          : "Notification fetch failed",
    };
  }
};
